<template>
  <transition name="fade">
  <div class="fs-loader" v-show="_fsLoading">

    <div class="loader">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <span class="loading animate-flicker" data-name="Loading" v-if="fsLoading">{{fsLoading.message}} </span>
    <!-- <div class="loading-label animated fadeIn infinite">Bezig met laden...</div> -->
  </div>
  </transition>
</template>
<script>
import { mapGetters } from 'vuex'
import * as types from '../../store/types'

export default {
  data(){
    return {

      fsLoading: false,
      running: false

    }
  },
  watch:{
    _fsLoading(nv){
      if(nv){
        let vm = this
        this.running = true
        setTimeout(() => {
            if(this.running){
                this.fsLoading = nv
            }
            this.running = false
        }, 100)
      }
      else{
        this.running = false
        this.fsLoading = nv
      }
    }
  },
  computed:{
    ...mapGetters({
        _fsLoading: types.FS_LOADING,
    }),

  }
}
</script>
<style scoped>

.fs-loader{
  top: 0;
  bottom: 0;
  width: 100%;
  position: fixed;
  transition: background-image 2s ease-in-out;
  z-index: 99999999999 !important;
  background-color: rgba(255,255,255,0.8);
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  flex-direction: column;
  /* margin-left: -260px; */
}

@keyframes loader {
  0%, 10%, 100% {
    width: 80px;
    height: 80px;
  }
  65% {
    width: 150px;
    height: 150px;
  }
}
@keyframes loaderBlock {
  0%, 30% {
    transform: rotate(0);
  }
  55% {
    background-color: #fff;
  }
  100% {
    transform: rotate(90deg);
  }
}
@keyframes loaderBlockInverse {
  0%, 20% {
    transform: rotate(0);
  }
  55% {
    background-color: #fff;
  }
  100% {
    transform: rotate(-90deg);
  }
}
.loader {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 80px;
  height: 80px;
  transform: translate(-50%, -50%) rotate(45deg) translate3d(0, 0, 0);
  animation: loader 1.2s infinite ease-in-out;
}
.loader span {
  position: absolute;
  display: block;
  width: 40px;
  height: 40px;
  background-color: #607D8B;
  animation: loaderBlock 1.2s infinite ease-in-out both;
}
.loader span:nth-child(1) {
  top: 0;
  left: 0;
}
.loader span:nth-child(2) {
  top: 0;
  right: 0;
  animation: loaderBlockInverse 1.2s infinite ease-in-out both;
}
.loader span:nth-child(3) {
  bottom: 0;
  left: 0;
  animation: loaderBlockInverse 1.2s infinite ease-in-out both;
}
.loader span:nth-child(4) {
  bottom: 0;
  right: 0;
}



.loading {
  font-size: 12px;
  margin-top: 180px;
letter-spacing: 0.1em;
display: block;
color: white;
position: relative;
top: 25px;
z-index: 2;
-moz-animation: text 0.5s ease infinite alternate;
-webkit-animation: text 0.5s ease infinite alternate;
animation: text 0.5s ease infinite alternate;
}


@keyframes fadeIn {
  from { opacity: 0.6; }
}

.animate-flicker {
    animation: fadeIn 1s infinite alternate;
}

.loading-label{
  margin-top: 240px;
  color: #777;
  font-size: 30px;
  font-weight: 200;
}

</style>
